import type { RecoilState, RecoilValueReadOnly } from 'recoil';
import { useCheckbox, useTranslation } from '@zurich/common/hooks';
import type { ValidationResult } from '@zurich/common/types';
import { Stack } from '@zurich/ui/atoms';
import { Checkbox, Notice } from '@zurich/ui/legacy/components';
import type { SummaryDataType } from '~/lib/types';
import { InfoSummaryCard } from './InfoSummaryCard';
import { StepLayout } from './StepLayout';

export interface InfoSummaryProps {
  summaryData: SummaryDataType[];
  atom: RecoilState<boolean | null>;
  validationSelector: RecoilValueReadOnly<ValidationResult> | undefined;
  finalCheck?: boolean;
  notice?: string;
  flexDirection?: 'column' | 'column-reverse';
}

export function InfoSummary({
  summaryData,
  atom,
  validationSelector,
  finalCheck,
  notice,
  flexDirection = 'column',
}: InfoSummaryProps) {
  const { t } = useTranslation();
  const confirmationProps = useCheckbox({
    atom,
    validationSelector,
    fieldName: finalCheck
      ? 'confirmationOfCorrectVSGAData'
      : 'confirmationOfCorrectAutoData',
    i18nPrefix: 'vsga:checkboxes.',
    nullable: true,
  });

  return (
    <StepLayout stepName="autoSummary">
      <Stack rowGap={3} flexDirection={flexDirection}>
        {notice && <Notice type="neutral">{notice}</Notice>}
        <Stack paddingX={2}>
          <Checkbox
            {...confirmationProps}
            label={t(
              finalCheck
                ? 'vsga:checkboxes.confirmationOfCorrectVSGAData.label'
                : 'vsga:checkboxes.confirmationOfCorrectAutoData.label'
            )}
          />
        </Stack>
        <InfoSummaryCard summaryData={summaryData} />
      </Stack>
    </StepLayout>
  );
}
